(function(){
  'use strict';
  if(window.__SHCROV106)return;
  window.__SHCROV106=true;

  var context=window.SH_CRO_CONTEXT||{};
  var REVIEWS_URL='/pages/reviews';
  var REVIEW_SCORE='4.8';
  var REVIEW_COUNT='1,500+';
  var recent={};
  var pendingAddSource='';

  function qs(selector,root){return (root||document).querySelector(selector);}
  function qsa(selector,root){return Array.prototype.slice.call((root||document).querySelectorAll(selector));}
  function text(node,value){if(node)node.textContent=value;}
  function isMobile(){return window.matchMedia&&window.matchMedia('(max-width:749px)').matches;}
  function productHandle(node){
    var card=node&&node.closest&&node.closest('[data-product-handle],[data-handle],[data-sh-uc-card],.sh-studio');
    if(!card)return '';
    return card.dataset.productHandle||card.dataset.handle||card.dataset.productHandle||'';
  }
  function dedupe(key,ms){
    var now=Date.now();
    if(recent[key]&&now-recent[key]<(ms||500))return false;
    recent[key]=now;
    return true;
  }
  function emit(name,detail){
    var payload=Object.assign({
      event:'sickhaus_'+name,
      cro_action:name,
      device:isMobile()?'mobile':'desktop',
      market:context.market||'',
      currency:context.currency||''
    },detail||{});
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('sickhaus:cro',{detail:payload}));
    if(typeof window.clarity==='function'){
      try{window.clarity('event','sickhaus_'+name);}catch(error){}
    }
  }

  function canonicalizeTrustRail(root){
    var scope=root&&root.querySelectorAll?root:document;
    var template=document.getElementById('SHConversionAssuranceTemplate');
    var containers=[];
    if(template&&template.content)containers.push(template.content);
    containers.push(scope);
    containers.forEach(function(container){
      qsa('.sh-assurance-capsule--rating',container).forEach(function(tile){
        if(tile.tagName!=='A'){
          var replacement=document.createElement('a');
          replacement.className=tile.className;
          replacement.innerHTML=tile.innerHTML;
          Array.prototype.slice.call(tile.attributes).forEach(function(attr){
            if(attr.name!=='class')replacement.setAttribute(attr.name,attr.value);
          });
          tile.replaceWith(replacement);
          tile=replacement;
        }
        tile.href=REVIEWS_URL;
        tile.setAttribute('aria-label','Read customer reviews — rated 4.8 out of 5 from more than 1,500 reviews');
        tile.style.color='inherit';
        tile.style.textDecoration='none';
        var strong=qs('.sh-assurance-capsule__copy strong',tile);
        var small=qs('.sh-assurance-capsule__copy small',tile);
        if(strong){
          strong.innerHTML='<span class="sh-assurance-copy--desktop">4.8 customer rating</span><span class="sh-assurance-copy--mobile">4.8 rating</span>';
        }
        text(small,'1,500+ reviews');
      });
    });
  }

  function canonicalizeHomepageReviews(root){
    var scope=root&&root.querySelectorAll?root:document;
    qsa('[class*="ai-testimonial-rating-panel-"]',scope).forEach(function(panel){
      var score=qs('[class*="ai-testimonial-rating-score-"]',panel);
      var caption=qs('[class*="ai-testimonial-rating-caption-"]',panel);
      text(score,REVIEW_SCORE);
      text(caption,REVIEW_COUNT+' reviews');
      panel.setAttribute('aria-label',REVIEW_SCORE+' out of 5 stars, '+REVIEW_COUNT+' reviews');
      var link=qs('[class*="ai-testimonial-rating-link-"]',panel);
      if(!link){
        var panelClass=Array.prototype.find.call(panel.classList,function(name){
          return name.indexOf('ai-testimonial-rating-panel-')===0&&name.indexOf('ai-testimonial-rating-panel--')!==0;
        });
        if(panelClass){
          var id=panelClass.slice('ai-testimonial-rating-panel-'.length);
          link=document.createElement('a');
          link.className='ai-testimonial-rating-link-'+id;
          link.textContent='Read all customer reviews';
          panel.appendChild(link);
        }
      }
      if(link)link.href=REVIEWS_URL;
    });

    if(location.pathname!=='/'&&location.pathname!=='')return;
    var replacements={
      '4.9★':'4.8★',
      '4.9★ from real people':'4.8★ from real people',
      '1,200+ reviews':'1,500+ reviews',
      '1,200+ verified reviews':'1,500+ reviews',
      'FROM 1,200+ VERIFIED REVIEWS':'1,500+ reviews',
      '1,337+ reviews':'1,500+ reviews',
      'Based on 1,804 reviews':'Based on 1,500+ reviews'
    };
    var walker=document.createTreeWalker(qs('main')||document.body,NodeFilter.SHOW_TEXT);
    var nodes=[];
    while(walker.nextNode())nodes.push(walker.currentNode);
    nodes.forEach(function(node){
      var clean=(node.nodeValue||'').trim();
      if(replacements[clean])node.nodeValue=node.nodeValue.replace(clean,replacements[clean]);
    });
  }

  function refineAnnouncement(){
    var threshold=context.threshold||'';
    var deliveryTerm=context.deliveryTerm||'delivery';
    qsa('[class*="ai-announcement-shipping-text-"]').forEach(function(node){
      node.textContent=('FREE '+deliveryTerm+' OVER '+threshold).toUpperCase();
    });
    var header=qs('header')||document;
    var walker=document.createTreeWalker(header,NodeFilter.SHOW_TEXT);
    var nodes=[];
    while(walker.nextNode())nodes.push(walker.currentNode);
    nodes.forEach(function(node){
      if((node.nodeValue||'').trim().toUpperCase()==='EASY RETURNS')node.nodeValue=node.nodeValue.replace(/EASY RETURNS/i,'60-DAY RETURNS');
    });
  }

  function strengthenProductReviews(root){
    var scope=root&&root.querySelectorAll?root:document;
    qsa('.sh-studio .buy__meta[data-sh-scroll-reviews]',scope).forEach(function(button){
      if(!qs('.sh-review-jump-v106',button)){
        var cue=document.createElement('span');
        cue.className='sh-review-jump-v106';
        cue.textContent='Read reviews →';
        button.appendChild(cue);
      }
      button.setAttribute('aria-label',(button.textContent||'Customer reviews').replace(/Read reviews →/,'').trim()+' — read reviews');
    });
  }

  function initOptionHierarchy(root){
    var scope=root&&root.querySelectorAll?root:document;
    qsa('.sh-studio .product-block',scope).forEach(function(block){
      if(block.dataset.shOptionHierarchyV106==='true')return;
      var options=qsa('[data-sh-option]',block).filter(function(option){return option.offsetParent!==null;});
      if(options.length<2)return;
      block.dataset.shOptionHierarchyV106='true';
      options[0].classList.add('sh-option-current');

      function setCurrent(option){
        options.forEach(function(item){item.classList.toggle('sh-option-current',item===option);});
      }
      function advance(option){
        option.classList.add('sh-option-visited');
        var next=options.find(function(item){return !item.classList.contains('sh-option-visited');});
        if(next){setCurrent(next);}else{
          options.forEach(function(item){item.classList.remove('sh-option-current');});
          var buy=block.closest('.sh-buy-sticky');
          if(buy)buy.classList.add('sh-options-complete');
        }
      }
      options.forEach(function(option){
        option.addEventListener('pointerdown',function(){setCurrent(option);},{passive:true});
        option.addEventListener('focusin',function(){setCurrent(option);});
        option.addEventListener('change',function(event){
          if(event.target&&event.target.matches('input,select'))advance(option);
        });
        option.addEventListener('click',function(event){
          if(event.target&&event.target.closest('label,button,[role="button"]')){
            window.setTimeout(function(){advance(option);},0);
          }
        });
      });
    });
  }

  function replaceCartRecommendations(){
    var source=document.getElementById('SHContextualCartRecommendationsV106');
    if(!source||!source.content)return;
    var target=qs('.sh-cart__recommendations');
    if(!target){
      var form=qs('.sh-cart form[data-sh-cart-form]');
      if(!form)return;
      target=document.createElement('section');
      target.className='sh-cart__recommendations';
      target.setAttribute('data-sh-cart-recommendations','');
      form.insertAdjacentElement('afterend',target);
    }
    if(target.dataset.shContextualV106==='true')return;
    target.innerHTML='';
    target.appendChild(source.content.cloneNode(true));
    target.dataset.shContextualV106='true';
  }

  function analyticsClick(event){
    var target=event.target&&event.target.closest?event.target.closest('button,a,label'):null;
    if(!target)return;

    var quick=target.closest('[data-sh-uc-quick],button[data-sh-quick],button[data-quick-add]');
    if(quick){
      pendingAddSource='quick_add';
      window.setTimeout(function(){
        if(qs('.sh-uc-drawer.is-open')&&dedupe('quick_add_open:'+productHandle(quick),700)){
          emit('quick_add_open',{product_handle:productHandle(quick),source:'product_card'});
        }
      },80);
    }

    var drawerOption=target.closest('.sh-uc-drawer__option,.sh-uc-drawer__palette-choice');
    if(drawerOption&&dedupe('variant_drawer:'+Date.now(),80)){
      emit('variant_selected',{product_handle:productHandle(drawerOption),source:'quick_add'});
    }


    var add=target.closest('.sh-uc-drawer__primary,.sh-studio [data-sh-main-cta] button,.sh-studio .add-to-cart,button[name="add"]');
    if(add){
      pendingAddSource=add.closest('.sh-uc-drawer')?'quick_add':'pdp';
    }

    var checkout=target.closest('[data-sh-cart-checkout],button[name="checkout"],a[href*="/checkout"]');
    if(checkout&&dedupe('checkout_start',900))emit('checkout_start',{source:'cart'});
  }

  function analyticsChange(event){
    var target=event.target;
    if(!target)return;
    if(target.matches('.sh-studio [data-variant-input],.sh-studio select,[data-sh-size-select]')){
      if(dedupe('variant_change:'+String(target.name||target.id||'')+':'+String(target.value||''),250)){
        emit('variant_selected',{product_handle:productHandle(target),source:'pdp'});
      }
    }
  }

  function initAnalytics(){
    if(window.__SHCROAnalyticsV106)return;
    window.__SHCROAnalyticsV106=true;
    window.addEventListener('click',analyticsClick,true);
    document.addEventListener('change',analyticsChange,true);
    document.addEventListener('ajaxProduct:added',function(event){
      var source=pendingAddSource||'ajax';
      pendingAddSource='';
      if(dedupe('add_to_bag:'+source,500))emit('add_to_bag',{source:source});
    });
    if(qs('[data-sh-cart-page]')&&dedupe('cart_view',10000)){
      emit('cart_view',{item_count:Number(qs('[data-sh-cart-page]').dataset.cartItemCount||0)});
    }
  }

  function boot(root){
    canonicalizeTrustRail(root||document);
    canonicalizeHomepageReviews(root||document);
    refineAnnouncement();
    strengthenProductReviews(root||document);
    initOptionHierarchy(root||document);
    replaceCartRecommendations();
    initAnalytics();
  }

  if(document.readyState==='complete'){
    window.requestAnimationFrame(function(){boot(document);});
  }else{
    document.addEventListener('DOMContentLoaded',function(){window.requestAnimationFrame(function(){boot(document);});},{once:true});
  }
  document.addEventListener('shopify:section:load',function(event){window.requestAnimationFrame(function(){boot(event.target||document);});});
  window.addEventListener('pageshow',function(){window.requestAnimationFrame(function(){boot(document);});});
})();
